import React, { useEffect, useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'Brands',
    href: '#brands'
  }, {
    name: 'Why Us',
    href: '#why-us'
  }, {
    name: 'Gallery',
    href: '#gallery'
  }, {
    name: 'Location',
    href: '#location'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#1a1a1a]/95 backdrop-blur-md py-4 shadow-lg' : 'bg-transparent py-6'}`} data-id="element-132">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-133">
        <div className="flex justify-between items-center" data-id="element-134">
          {/* Logo */}
          <div className="flex items-center" data-id="element-135">
            <a href="#" className="text-2xl font-bold tracking-tighter text-white uppercase" data-id="element-136">
              Eurosport <span className="text-[#c41e3a]" data-id="element-137">Auto Care</span>
            </a>
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-138">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-gray-300 hover:text-white transition-colors text-sm font-medium tracking-wide uppercase" data-id="element-139">
                {link.name}
              </a>)}
            <a href="tel:4107980900" className="flex items-center gap-2 px-4 py-2 border border-[#c41e3a] text-[#c41e3a] hover:bg-[#c41e3a] hover:text-white transition-all duration-300 rounded-sm text-sm font-bold uppercase tracking-wider" data-id="element-140">
              <Phone size={16} data-id="element-141" />
              (410) 798-0900
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-142">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-white p-2" aria-label="Toggle menu" data-id="element-143">
              {isMobileMenuOpen ? <X size={24} data-id="element-144" /> : <Menu size={24} data-id="element-145" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-146">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-[#1a1a1a] border-t border-gray-800" data-id="element-147">
            <div className="px-4 pt-4 pb-8 space-y-4" data-id="element-148">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="block text-gray-300 hover:text-white text-lg font-medium" data-id="element-149">
                  {link.name}
                </a>)}
              <a href="tel:4107980900" className="block w-full text-center mt-6 px-4 py-3 bg-[#c41e3a] text-white font-bold uppercase tracking-wider" data-id="element-150">
                Call Now
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}